<script setup>
const props = defineProps({
  meta: {
    type: Object,
    required: true
  }
})

const route = useRoute()
const prev = computed(() => {
  if (props.meta.current_page === 1) {
    return null
  }

  return props.meta.current_page - 1
})

const next = computed(() => {
  if (props.meta.current_page === props.meta.last_page) {
    return null
  }

  return props.meta.current_page + 1
})

const paginationRoute = (direction) => {
  const queryString = new URLSearchParams(route.query)
  queryString.set('page',
    direction === 'next'
      ? next.value
      : direction === 'previous'
        ? prev.value
        : null)

  return `/blog?${queryString.toString()}`
}
</script>

<template>
  <div
    class="relative mx-4 mt-10 flex max-w-screen-xl items-center md:mx-10 xl:mx-auto xl:px-4"
    :class="prev ? 'justify-between' : 'justify-end'">
    <NuxtLink
      v-if="prev"
      :to="paginationRoute('previous')"
      class="btn-primary px-5 py-3">
      <span>
        Previous
      </span>
    </NuxtLink>
    <NuxtLink
      v-if="next"
      :to="paginationRoute('next')"
      class="btn-primary px-5 py-3">
      <span>
        Next
      </span>
    </NuxtLink>
  </div>
</template>
